var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2569_2065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 12.5024V13.5024C13.4995 13.7677 13.3942 14.022 13.2066 14.2095C13.0191 14.3971 12.7647 14.5024 12.4995 14.5024H9.49951",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 2.50244H12.4995C12.7647 2.50244 13.0191 2.6078 13.2066 2.79533C13.3942 2.98287 13.4995 3.23723 13.4995 3.50244V4.50244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92885 15.4975L0.928845 14.6402C0.809742 14.6232 0.700763 14.5638 0.621902 14.4729C0.543042 14.3821 0.499588 14.2658 0.499512 14.1455V2.48352C0.499418 2.36902 0.538625 2.25796 0.610581 2.16889C0.682537 2.07982 0.782882 2.01815 0.894845 1.99419L6.89485 0.513519C6.96777 0.497907 7.04327 0.498807 7.1158 0.516153C7.18834 0.5335 7.25608 0.566853 7.31405 0.613769C7.37202 0.660686 7.41877 0.719977 7.45086 0.7873C7.48295 0.854623 7.49957 0.928272 7.49951 1.00285V15.0029C7.49947 15.0745 7.48404 15.1452 7.45428 15.2103C7.42452 15.2755 7.38112 15.3335 7.32701 15.3804C7.2729 15.4273 7.20935 15.462 7.14066 15.4822C7.07197 15.5024 6.99973 15.5076 6.92885 15.4975Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 6.50195L15.4995 8.50195H9.99951",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 10.6665L15.3335 8.6665",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2495 7.75267C5.19994 7.75267 5.1515 7.7674 5.11033 7.79499C5.06916 7.82258 5.03712 7.86179 5.01828 7.90762C4.99944 7.95346 4.99465 8.00386 5.00451 8.05243C5.01438 8.101 5.03846 8.14554 5.07369 8.18039C5.10892 8.21524 5.15371 8.23884 5.20238 8.24818C5.25105 8.25753 5.3014 8.2522 5.34703 8.23286C5.39266 8.21353 5.43152 8.18107 5.45867 8.13961C5.48581 8.09815 5.50003 8.04956 5.4995 8C5.49959 7.96715 5.49318 7.9346 5.48065 7.90423C5.46811 7.87385 5.4497 7.84626 5.42647 7.82303C5.40324 7.7998 5.37564 7.78138 5.34527 7.76885C5.3149 7.75632 5.28235 7.74991 5.2495 7.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e3ecef32e64ec1b7c657337b0f9e20dc.svg";
export { ForwardRef as ReactComponent };